import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Section } from './ui/Section';
import { ChevronDownIcon } from 'lucide-react';
interface FAQItemProps {
  question: string;
  answer: string;
}
function FAQItem({
  question,
  answer
}: FAQItemProps) {
  const [isOpen, setIsOpen] = useState(false);
  return <div className="border-b border-warm-gray last:border-0" data-id="element-90">
      <button onClick={() => setIsOpen(!isOpen)} className="w-full py-6 flex items-center justify-between text-left focus:outline-none group" data-id="element-91">
        <span className="text-lg font-medium text-navy group-hover:text-teal transition-colors pr-8" data-id="element-92">
          {question}
        </span>
        <ChevronDownIcon className={`h-5 w-5 text-gray-400 transition-transform duration-300 ${isOpen ? 'rotate-180' : ''}`} data-id="element-93" />
      </button>
      <AnimatePresence data-id="element-94">
        {isOpen && <motion.div initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: 'auto',
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} transition={{
        duration: 0.3
      }} className="overflow-hidden" data-id="element-95">
            <p className="pb-6 text-gray-600 leading-relaxed" data-id="element-96">{answer}</p>
          </motion.div>}
      </AnimatePresence>
    </div>;
}
export function FAQSection() {
  const faqs = [{
    question: '¿Cuánto dura?',
    answer: '10 minutos diarios (hasta 15 si quieres). + Emergencia 5 min cuando suba.'
  }, {
    question: '¿Necesito experiencia meditando?',
    answer: "No. Está diseñado para principiantes y personas que no logran 'poner la mente en blanco'."
  }, {
    question: '¿Es muy “terapia”?',
    answer: 'No. Es práctico, cotidiano y directo. No analizamos tu infancia, regulamos tu sistema nervioso hoy.'
  }, {
    question: '¿Y si un día fallo?',
    answer: 'No reinicias. Sigues. El sistema aprende repetición, no perfección.'
  }];
  return <Section id="faq" background="warm" data-id="element-97">
      <div className="max-w-2xl mx-auto" data-id="element-98">
        <h2 className="text-3xl font-bold text-navy mb-8 text-center" data-id="element-99">
          Preguntas Frecuentes
        </h2>
        <div className="bg-white rounded-2xl shadow-sm border border-warm-gray px-6 md:px-8" data-id="element-100">
          {faqs.map((faq, i) => <FAQItem key={i} {...faq} data-id="element-101" />)}
        </div>
      </div>
    </Section>;
}